import { render, staticRenderFns } from "./light-device.vue?vue&type=template&id=0e6c5963&scoped=true"
import script from "./light-device.vue?vue&type=script&lang=js"
export * from "./light-device.vue?vue&type=script&lang=js"
import style0 from "@/utils/style/public-style.css?vue&type=style&index=0&id=0e6c5963&prod&scoped=true&lang=css&external"
import style1 from "./light-device.vue?vue&type=style&index=1&id=0e6c5963&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e6c5963",
  null
  
)

export default component.exports